import { useState } from 'react';
import serviceMethods from "../../service";
import Modal from "../Modal";
import { useModal } from "../../contexts/modal";
import { Button } from "@art-of-hospitality-solutions-llc/ui-kit/components/button";
import ShowFor from "@Components/ShowFor";

const TriggerList = ({ triggers, setTriggers, userId }) => {
  const [selectedTriggerIds, setSelectedTriggerIds] = useState([]);
  const [modalContent, setModalContent] = useState(null);
  const { openModal, closeModal } = useModal();
  const { deleteTriggers, toggleTriggerActive } = serviceMethods;

  const isAllSelected = triggers.length > 0 && selectedTriggerIds.length === triggers.length;

  const toggleSelectAll = () => {
    if (isAllSelected) {
      setSelectedTriggerIds([]);
    } else {
      setSelectedTriggerIds(triggers.map(trigger => trigger.id));
    }
  };

  const toggleSelectOne = (id) => {
    setSelectedTriggerIds((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter(triggerId => triggerId !== id)
        : [...prevSelected, id]
    );
  };

  const handleOpenModal = () => {
    setModalContent("delete");
    openModal();
  };

  const handleDelete = async () => {
    closeModal();
    const deleteRes = await deleteTriggers(selectedTriggerIds, userId)
    const deletedIds = await deleteRes.json()
    if (deletedIds.length > 0) {
      setTriggers((prevTriggers) => {
        return prevTriggers.filter((trigger) => !deletedIds.includes(trigger.id))
      })
      setSelectedTriggerIds([])
    }
  };

  const handleActiveToggle = async (status) => {
    const toggleRes = await toggleTriggerActive(selectedTriggerIds, status)
    const toggledObj = await toggleRes.json()
    const { ids, activeStatus } = toggledObj
    if (ids.length > 0) {
      setTriggers((prevTriggers) => {
        return prevTriggers.map((trigger) => {
          if (ids.includes(trigger.id)) {
            trigger.active = status
          }
          return trigger;
        })
      })
    }
  };

  return (
    <div className="overflow-x-auto p-4">
      <table className="min-w-full bg-white border border-gray-200">
        <thead >
          <tr className="">
            <th className="px-4 py-2 border-b">
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={toggleSelectAll}
              />
            </th>
            <th className="px-4 py-2 border-b text-left text-sm font-medium text-gray-700">Trigger Title</th>
            <th className="px-4 py-2 border-b text-left text-sm font-medium text-gray-700">Flow Stage ID</th>
            <th className="px-4 py-2 border-b text-left text-sm font-medium text-gray-700">Type</th>
            <th className="px-4 py-2 border-b text-left text-sm font-medium text-gray-700">Status</th>
          </tr>
        </thead>
        <tbody>
          {triggers.map((trigger) => (
            <tr key={trigger.id} className={`hover:bg-gray-100`}>
              <td className="px-4 py-2 border-b">
                <input
                  type="checkbox"
                  checked={selectedTriggerIds.includes(trigger.id)}
                  onChange={() => toggleSelectOne(trigger.id)}
                />
              </td>
              <td className="px-4 py-2 border-b text-left text-sm font-medium text-gray-700">{trigger.title}</td>
              <td className="px-4 py-2 border-b text-left text-sm font-medium text-gray-700">{trigger.flowStageId}</td>
              <td className="px-4 py-2 border-b text-left text-sm font-medium text-gray-700">{trigger.conditions.type}</td>
              <td className="px-4 py-2 border-b text-left text-sm font-medium text-gray-700">{trigger.active ? 'On' : 'Off'}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <ShowFor permissions={['TRIGGER_WRITE']}>
        <div className="flex gap-8 mt-4">
          <div className='flex gap-2'>
            <Button
              onClick={() => handleActiveToggle(true)}
              disabled={selectedTriggerIds.length === 0}
            >
              On
            </Button>

            <Button
              onClick={() => handleActiveToggle(false)}
              disabled={selectedTriggerIds.length === 0}
            >
              Off
            </Button>
          </div>

          <Button
            variant="destructive"
            onClick={() => handleOpenModal()}
            disabled={selectedTriggerIds.length === 0}
          >
            Delete Selected
          </Button>
        </div>
      </ShowFor>

      {modalContent === "delete" && (
        <Modal className={'max-w-xl'}>
          <div className='flex flex-col p-8 items-center'>
            <h2 className="text-lg font-bold">Delete selected Triggers.</h2>
            <h3 className="text-lg mb-4">Are you sure?</h3>
            <div className='flex gap-4'>
              <Button
                className='border rounded px-2 py-1 hover:bg-red-500 active:bg-red-600'
                onClick={() => handleDelete()}
              >
                Delete
              </Button>

              <Button
                className='border rounded px-2 py-1 hover:bg-gray-300 active:bg-gray-500'
                onClick={() => closeModal()}
              >
                Cancel
              </Button>
            </div>
          </div>

        </Modal>
      )}

    </div>
  );
};

export default TriggerList;
